import ThemeProvider, { DEFAULT_THEME } from '@pixum/theme-provider';
import Text, { TEXT_TAG, TEXT_VARIANT } from '@pixum/text';
import Icon from '@pixum/icon';
import type { NewsletterSuccessMessageBoxProps } from '../types';
import '../styles.css';

/**
 * Renders the confirmation message shown after newsletter registration succeeds.
 *
 * @param constants - Localized success headline and message.
 * @param theme - Optional theme inherited from the magazine section.
 */
export function NewsletterSuccessMessageBox({ constants, theme }: NewsletterSuccessMessageBoxProps) {
  const newsletterSuccessHeadline = constants.i18n_newsletter_registration_success;
  const newsletterSuccessText = constants.i18n_newsletter_registration_success_text;

  return (
    <ThemeProvider theme={theme || DEFAULT_THEME}>
      <div className="newsletter-magazine__message-box">
        <Icon name="check-circle" size={'medium'} color="var(--color-surface-highlight)" />
        <div className="newsletter-magazine__message-box__text">
          <Text tag={TEXT_TAG.STRONG} variant={TEXT_VARIANT.HEADLINE}>
            {newsletterSuccessHeadline}
          </Text>
          <Text variant={TEXT_VARIANT.CAPTION}>{newsletterSuccessText}</Text>
        </div>
      </div>
    </ThemeProvider>
  );
}
